import { render } from "./PantryListItem.vue?vue&type=template&id=fc874a86&ts=true"
import script from "./PantryListItem.vue?vue&type=script&lang=ts"
export * from "./PantryListItem.vue?vue&type=script&lang=ts"

import "./PantryListItem.vue?vue&type=style&index=0&id=fc874a86&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__